module.exports = __webpack_public_path__ + "img/4.14f998b2.webp";